var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":""}},[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ path: `/clients/${_vm.clientId}` }}},[_vm._v(" "+_vm._s(_vm.clientName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }